import React from 'react';

let Image = function imageFeedPic(props) {
 
  /*let style = {
    width: '200px',
    margin: '10px 5px 0px 5px'
  };*/

  return (
    <img src={props.source.sizes.medium} key={props.source.id} alt={props.source.alt} width={props.source.sizes['medium-width']} height={props.source.sizes['medium-height']} />
    
  );
};

export default Image;



// WEBPACK FOOTER //
// ./src/Image.jsx